export const ContentTitle = ({ title }: { title: string }) => (
  <div className="p2-medium mt-[12px] line-clamp-2 w-full overflow-ellipsis">
    {title}
  </div>
);
